export const actionTypes = {
  ON_CREATE_APPOINMENT: "on-create-appoinment",
  ON_LOADING_APPOINMENT: "on-loading-appoinment",
  ON_SUCCESS_APPOINMENT: "on-success-appoinment",
  ON_DATA_APPOINMENT: "on-data-appoinment",
  ON_ERROR_APPOINMENT: "on-error-appoinment",
  ON_QUERY_DATA_APPOINMENT: "on-query-data-appoinment",
  ON_DEFAULT_DATA_APPOINMENT: "on-default-data-appoinment",
  ON_LOADING_DELETE_DATA_APPOINMENT: "on-loading-delete-data-appoinment",
  ON_SUCCESS_DELETE_DATA_APPOINMENT: "on-success-delete-data-appoinment",
};

export const initialState = {
  appoinments: [],
  isLoading: false,
  error: null,
  count: 0,
  total: 0,
  pagination: {},
  appoinmentDeleteLoading: false,
};
